import { IconCirclePlus, IconSearch } from "@tabler/icons-react";

const TabTarifas = ({ tarifas = [], onEditar, busqueda, setBusqueda, abrirModal }) => {
  return (
    <>
      <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-4">
        <div className="input-icon" style={{ minWidth: "300px" }}>
          <input type="text" className="form-control" placeholder="Buscar por tipo de móvil o tag..." value={busqueda} onChange={(e) => setBusqueda(e.target.value)} />
          <span className="input-icon-addon">
            <IconSearch size={18} />
          </span>
        </div>

        <button className="btn btn-pill btn-primary" onClick={abrirModal} title="Agregar nueva tarifa" aria-label="Agregar nueva tarifa">
          <IconCirclePlus size={18} className="me-1" />
          Agregar Tarifa
        </button>
      </div>

      <div className="table-responsive">
        <table className="table table-hover table-striped table-vcenter">
          <thead>
            <tr>
              <th>Tipo Móvil</th>
              <th>Tag</th>
              <th>Mínimo</th>
              <th>Km</th>
              <th>Bandera</th>
              <th>Estado</th>
              <th>Creado por</th>
            </tr>
          </thead>
          <tbody>
            {tarifas.length > 0 ? (
              tarifas.map((tarifa) => (
                <tr key={tarifa.id} onClick={() => onEditar?.(tarifa)} style={{ cursor: "pointer" }}>
                  <td>{tarifa.tipo_movil}</td>
                  <td>${tarifa.tag_rate}</td>
                  <td>${tarifa.min_rate}</td>
                  <td>${tarifa.km_rate}</td>
                  <td>${tarifa.bandera}</td>
                  <td>
                    <span className="d-inline-flex align-items-center">
                      <span className={`badge me-1 ${tarifa.estado === 1 ? "bg-success" : "bg-secondary"}`}></span>
                      {tarifa.estado === 1 ? "Activo" : "Inactivo"}
                    </span>
                  </td>
                  <td>{tarifa.username}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="text-center text-muted">
                  No se encontraron tarifas.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default TabTarifas;
